import { withHandlers } from 'recompose'

import { getDateTimeFormat } from 'i18n/utils'
import TableCell from 'shared/components/TableCell'
import { cancelWaitingList } from 'grs/actions'
import { reservationSelector, cancelWaitingListRecordPendingSelector } from 'dashboard-transactions/selectors'
import DeleteButton from '@components/DeleteButton'

import styles from './styles.module.scss'

const enhance = compose(
    connect(
        createStructuredSelector({
            reservation: reservationSelector,
            pending: cancelWaitingListRecordPendingSelector,
        }),
        { cancelWaitingList }
    ),
    withHandlers({
        onClickCancel:
            ({ reservation, cancelWaitingList }) =>
            () =>
                cancelWaitingList(reservation.waitingListKey),
    })
)

const WaitingListRecord = ({
    pending,
    reservation: { isConfirmed, locationId, rateId, createdDate, location, expiryDate, waitingListKey },
    onClickCancel,
}) => (
    <div className={styles.tableRow}>
        <TableCell fieldName={<T>dashboard.label.joinDate</T>} className={styles.joinDate}>
            <span>{createdDate.format(getDateTimeFormat())}</span>
        </TableCell>
        <TableCell fieldName={<T>dashboard.label.type</T>} className={styles.type}>
            <T>dashboard.label.waitingList</T>
        </TableCell>
        <TableCell fieldName={<T>dashboard.label.location</T>} className={styles.location}>
            {location}
        </TableCell>
        <TableCell fieldName={<T>dashboard.label.book</T>} className={styles.book}>
            <Link
                className={`btn btn-primary ${isConfirmed ? '' : 'disabled'}`}
                disabled={!isConfirmed}
                to={
                    isConfirmed
                        ? {
                              pathname: `/booking/${locationId}/subscriptions`,
                              search: { rateId, waitingListKey },
                          }
                        : ''
                }>
                <T>dashboard.label.book</T>
            </Link>
        </TableCell>
        <TableCell fieldName={<T>dashboard.label.dueDate</T>} className={styles.dueDate}>
            {isConfirmed ? expiryDate.format(getDateTimeFormat()) : '-'}
        </TableCell>
        <TableCell className={styles.actions}>
            <DeleteButton onClick={onClickCancel} pending={pending} />
        </TableCell>
    </div>
)

export default enhance(WaitingListRecord)
